/**
 * @file dashboard-texts.ts
 * @description Тексты страницы «Обзор склада» (phase19.24 этап 1, шаг 3;
 * phase19.31 шаг О4 — макеты (в), (в2) и §3 разбора зоны «Склад»).
 *
 * Один источник фраз для страницы и её блоков: заголовки, пустые состояния,
 * ошибки, подписи кнопок. Реестры плиток и групп «Что нужно сделать» живут
 * отдельно (`dashboard-counters.ts`, `dashboard-attention-groups.ts`).
 */

/** Тексты экрана — один источник для блоков, пустых состояний и ошибок. */
export const DASHBOARD_TEXT = {
  title: "Обзор склада",
  warehouseLabel: "Склад",
  allWarehouses: "Все склады",
  countersLabel: "Показатели склада",
  queueTitle: "Очередь сборки",
  queueAll: "Все задания",
  queueEmpty: "Заданий на сборку нет",
  queueEmptyHint: "Появятся, когда заказ перейдёт на стадию «На сборке»",
  attentionTitle: "Что нужно сделать",
  attentionEmpty: "Всё в порядке",
  movementsTitle: "Последние движения",
  movementsAll: "Весь журнал",
  emptyTitle: "Склад пока пуст",
  emptyDescription: "Начните с приёмки — товар появится в остатках.",
  loadError: "Не удалось загрузить обзор склада. Реестры склада доступны в меню.",
  retry: "Повторить",
  newReceipt: "Приёмка",
  newReceiptLabel: "Новая приёмка",
  newTransfer: "Новое перемещение",
  newWriteoff: "Новое списание",
  actionsTitle: "Действия со складом",
  chooseWarehouse: "Склад",
} as const;

/** «На складе «Основной» сегодня нет заданий и проблем». */
export function quietWarehouseText(name: string): string {
  return `На складе «${name}» сегодня нет заданий и проблем`;
}

/** «Нет сети. Показаны данные на 14:32». */
export function offlineText(time: string): string {
  return `Нет сети. Показаны данные на ${time}`;
}

/** Пояснение заголовка: «Основной склад · сегодня, 2 октября». */
export function dashboardSubtitle(warehouseName: string, today: string): string {
  return `${warehouseName} · сегодня, ${today}`;
}
